// Messages.jsx
import React, { useEffect, useState, useRef } from "react";
import "./messages.css";
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";
import { Form, Button, Modal } from "react-bootstrap";

const Messages = ({ show = false, onClose = () => {}, initialRFQ = null,initialSupplier = null ,chatContext}) => {
  const [rfqs, setRFQs] = useState([]);
  const [selectedRFQ, setSelectedRFQ] = useState(null);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [supportMessage, setSupportMessage] = useState({ subject: "", content: "" });
  const [errorSupportMessage, setErrorSupportMessage] = useState({ subject: false, content: false });
  const [itemPics, setItemPics] = useState([]);
  const [loader, setLoader] = useState(false);
  const chatBodyRef = useRef(null);
  const fileInputRef = useRef(null);

  const userDetails = JSON.parse(localStorage.getItem("user_details"));
  const user_id = userDetails?.id;
  const user_role = userDetails?.role; // 2 = supplier, 3 = user
useEffect(() => {
  if (initialRFQ?.id) {
    setSelectedRFQ(initialRFQ);
  }
}, [initialRFQ]);

useEffect(() => {
  if (initialSupplier) {
    setSelectedSupplier({ id: initialSupplier });
  }
}, [initialSupplier]);


  // Scroll to bottom when messages update
  useEffect(() => {
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    }
  }, [messages, selectedRFQ, selectedSupplier]);

  // Fetch messages
  const getMessages = async () => {
    setLoading(true);
    try {
      const res = await apicall.get(`messages/${user_id}`);
      
      if (!res?.success) {
        toast.error("Failed to load messages");
        return;
      }

      const raw = res.data;
      console.log(raw,"raw")

      // Build unique RFQ list
     const uniqueRFQs = Object.values(
  raw.reduce((acc, item) => {
    if (!acc[item.rfq_id]) {
      acc[item.rfq_id] = {
        id: item.rfq_id,
        encryptedId: item.encryptedId,
        title: item.rfq_title || "Unnamed",
        user: item.rfq_owner_id || item.user_id || item.user,

        orderId: item.order_id   // 👈 ADD THIS
      };
    }
    return acc;
  }, {})
);


      setRFQs(uniqueRFQs);

      // Set default RFQ
      if (!selectedRFQ && uniqueRFQs.length > 0) {
        setSelectedRFQ(uniqueRFQs[0]);
      }

      setMessages(raw);
    } catch (e) {
      console.error("getMessages error:", e);
      toast.error("Error loading messages");
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
  getMessages();
}, []);


  // RFQ -> supplier list (only for users)
  const rfqSuppliers = selectedRFQ && user_role === 3
    ? messages
        .filter((msg) => msg.rfq_id === selectedRFQ.id && msg.role === 2)
        .reduce((acc, msg) => {
          const id = msg.sender_id;
          if (!acc.find((s) => s.id === id)) {
            const unread = messages.filter(
              m => m.rfq_id === selectedRFQ.id &&
                   m.receiver_id === user_id &&
                   m.sender_id === id &&
                   m.is_read === 0
            ).length;
            acc.push({ id, name: msg.name || msg.supplier_name || `Supplier ${id}`, unread });
          }
          return acc;
        }, [])
    : [];
const lastReadRef = useRef("");

const markRead = async (rfqId, senderId) => {
  try {
    const body = { 
      rfq_id: rfqId, 
      receiver_id: user_id,
      sender_id: senderId || null
    };
    await apicall.post(body, "markRead");
  } catch (e) {
    console.error("markRead error", e);
  }
};
useEffect(() => {
  if (!show || !selectedRFQ) return;

  let senderId = null;

  if (userDetails?.company_type_id === 1) {
    if (!selectedSupplier?.id) return;
    senderId = selectedSupplier.id;
  } else {
    senderId = selectedRFQ.user;
  }

  const key = `${selectedRFQ.id}_${senderId}`;

  // 🛑 prevent duplicate calls
  if (lastReadRef.current === key) return;

  lastReadRef.current = key;
  markRead(selectedRFQ.id, senderId);

}, [show, selectedRFQ?.id, selectedSupplier?.id]);


  // On RFQ click
const onSelectRFQ = (r) => {
  setSelectedRFQ(r);
  setSelectedSupplier(null);
  // DO NOT call markRead here
};

const onSelectSupplier = (s) => {
  setSelectedSupplier(s);
  // DO NOT call markRead here
};


  const handleChange = (e, key) => setSupportMessage({ ...supportMessage, [key]: e.target.value });

  const selectImage = (e) => {
    const files = Array.from(e.target.files);
    const fileURLs = files.map((file) => URL.createObjectURL(file));
    setItemPics([...itemPics, ...fileURLs]);
  };

  const deleteImage = (image) => setItemPics(itemPics.filter((img) => img !== image));

  const mailsendFun = () => {
    setSupportMessage({ subject: "", content: "" });
    setErrorSupportMessage({ subject: false, content: false });
    setItemPics([]);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

const sendMessage = async () => {
  let flag = true;
  let error = { ...errorSupportMessage };

  if (supportMessage.subject.trim() === "") {
    error.subject = true;
    flag = false;
  }
  if (supportMessage.content.trim() === "") {
    error.content = true;
    flag = false;
  }

  setErrorSupportMessage(error);
  if (!flag) return;

  try {
    setLoader(true);

    const allImages = await Promise.all(
      itemPics.map(async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      })
    );

    // ---------- DETERMINE RECEIVER ----------
    let receiverId;

    if (userDetails?.company_type_id === 1) {
      receiverId = selectedSupplier?.id; // Buyer → Supplier
    } else {
      receiverId = selectedRFQ?.user; // Supplier → Buyer
    }

    if (!receiverId || receiverId === user_id) {
      toast.error("Invalid receiver");
      return;
    }

    const payload = {
      rfq_id: selectedRFQ?.id,
      sender_id: user_id,
      receiver_id: receiverId,
      subject: supportMessage.subject,
      content: supportMessage.content,
      allImages,
      context: chatContext || "RFQ", 
    };
    console.log(payload,"payload")

    const res = await apicall?.post(payload, "inquiry");
console.log(res?.data,"res")
    // ✅ CORRECT SUCCESS CHECK
    if (res?.success) {
      toast.success("Message sent successfully!");
      mailsendFun();
      await getMessages();

  // ✅ Mark this conversation as read
  let receiverId;
  if (userDetails?.company_type_id === 1) {
    receiverId = selectedSupplier?.id;
  } else {
    receiverId = selectedRFQ?.user;
  }
  if (receiverId) {
    await markRead(selectedRFQ?.id, receiverId);
  }

  // Update unread count in Layout via localStorage or callback
  localStorage.setItem("chatUpdated", Date.now());

      
    } else {
      toast.error(res?.message || "Failed to send message");
    }

  } catch (e) {
    console.error("sendMessage err", e);
  } finally {
    setLoader(false);
  }
};


  // Default supplier for users
  useEffect(() => {
    if (selectedRFQ && rfqSuppliers.length > 0 && user_role === 3) {
      setSelectedSupplier(prev => rfqSuppliers.find(s => s.id === prev?.id) || rfqSuppliers[0]);
    }
    // For supplier: selectedSupplier is always RFQ owner
    if (selectedRFQ && user_role === 3) {
      setSelectedSupplier({ id: selectedRFQ.user, name: "User" });
    }
  }, [selectedRFQ, messages]);

  // Filter messages to display
  const filteredMessages = messages.filter(msg => {
    if (!selectedRFQ || msg.rfq_id !== selectedRFQ.id) return false;
    if (!selectedSupplier) return true;

    
  if (chatContext?.context === "ORDER_PAGE" && msg?.context !== "ORDER_PAGE") {
    return false;
  }

    if (userDetails.company_type_id === 2) {
      // Supplier sees messages with user
      return (msg.sender_id === user_id && msg.receiver_id === selectedRFQ.user) ||
             (msg.sender_id === selectedRFQ.user && msg.receiver_id === user_id);
    } else {
      // User sees messages with selected supplier
      return (msg.sender_id === user_id && msg.receiver_id === selectedSupplier.id) ||
             (msg.sender_id === selectedSupplier.id && msg.receiver_id === user_id);
    }
  });

  return (
  <div className="messages-container" style={{ height: "100%", display: "flex", flexDirection: "column" }}>


      <div style={{ maxHeight: "80vh", overflow: "hidden" }}>
    <div className="chat-header p-3 border-bottom d-flex justify-content-between align-items-center">
    <h5>Messages</h5>
    {/* <button className="btn-close" onClick={onClose}></button> */}
  </div>

<div className="messages-layout">
          {/* RFQ Tabs */}
           <div className="rfq-sidebar">
    {rfqs.map(r => (
      <div
        key={r.id}
        className={`rfq-tab ${selectedRFQ?.id === r.id ? "active" : ""}`}
        onClick={() => onSelectRFQ(r)}
      >
        <div className="rfq-id">
  RFQ-2025-{r.id}
  {r.orderId && `-Order-${r.orderId}`}
</div>

        <div className="rfq-sub">{r.title}</div>
      </div>
    ))}
  </div>

          <div className="chat-section">
    {/* Supplier Tabs */}
    {user_role === 3 && (
      <div className="supplier-tabs">
        {rfqSuppliers.map(s => (
          <div
            key={s.id}
            className={`supplier-tab ${selectedSupplier?.id === s.id ? "active" : ""}`}
            onClick={() => onSelectSupplier(s)}
          >
            <span className="supplier-name">{s.name}</span>
            {s.unread > 0 && <span className="unread-badge">{s.unread}</span>}
          </div>
        ))}
      </div>
    )}

           <div className="chat-body" ref={chatBodyRef}>
      {filteredMessages.map((msg, index) => {
        const isMine = Number(msg.sender_id) === Number(user_id);
        return (
          <div key={index} className={`msg-row ${isMine ? "user" : "supplier"}`}>
            <div className={`msg-bubble ${isMine ? "user" : "supplier"}`}>
              <p className="msg-text">{msg.subject}</p>
              <p className="msg-text">{msg.content}</p>
             {Array.isArray(msg.image_urls) && msg.image_urls.length > 0 && (
  <div className="msg-attachments">
    {msg.image_urls.map((url, i) => (
      <div key={i}>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="msg-file-link"
        >
       image: {url}
        </a>
      </div>
    ))}
  </div>
)}

              <span className="msg-time">
                {new Date(msg.created).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
              </span>
            </div>
          </div>
        );
      })}
    </div>


          {/* Chat Input */}
          {selectedSupplier && (
            <div className="chat-input-box p-3">
              <Form>
                <Form.Group className="mb-2">
                  <Form.Control
                    type="text"
                    placeholder="Enter subject"
                    value={supportMessage.subject}
                    onChange={(e) => handleChange(e, "subject")}
                    isInvalid={errorSupportMessage.subject}
                    size="sm"
                  />
                </Form.Group>

                <Form.Group className="mb-2">
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Type your message..."
                    value={supportMessage.content}
                    onChange={(e) => handleChange(e, "content")}
                    isInvalid={errorSupportMessage.content}
                    size="sm"
                  />
                </Form.Group>

                <Form.Group className="mb-2">
                  <label className="btn btn-outline-secondary btn-sm me-2" htmlFor="fileUpload">
                    Attach Document
                  </label>
                  <input
                    id="fileUpload"
                    ref={fileInputRef}
                    type="file"
                    multiple
                    accept="image/*,application/pdf"
                    onChange={selectImage}
                    style={{ display: "none" }}
                  />
                  {itemPics.length > 0 && <small>{itemPics.length} file(s) selected</small>}
                </Form.Group>

                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                 <Button
  onClick={sendMessage}
  disabled={loader || !selectedSupplier}
  style={{ background: "#d01c4c", border: "none", borderRadius: "10px", width: "50px" }}
  size="sm"
>
  {loader ? "Sending..." : "Send"}
</Button>

                </div>
              </Form>
            </div>
          )}
        </div>
      </div>
      </div>
      </div>
  );
};

export default Messages;
